exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content__header{display:flex;justify-content:space-between;width:100%;padding-bottom:1rem}.content__header .search--wrapper{flex:1;padding-right:2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/ContentHeader/ContentHeader.scss
// module id = 669
// module chunks = 0